// DB (snake_case) <-> JS (camelCase) mapping

export function termFromDb(row) {
  return {
    id: row.id,
    name: row.name,
    startDate: row.start_date || '',
    endDate: row.end_date || '',
  }
}

export function termToDb(term, userId) {
  return {
    id: term.id,
    user_id: userId,
    name: term.name,
    start_date: term.startDate || '',
    end_date: term.endDate || '',
  }
}

export function taskFromDb(row) {
  return {
    id: row.id,
    title: row.title,
    dueDate: row.due_date || '',
    priority: row.priority || 'medium',
    size: row.size || 'medium',
    subtasks: row.subtasks || [],
  }
}

export function taskToDb(task, termId, userId) {
  return {
    id: task.id,
    term_id: termId,
    user_id: userId,
    title: task.title,
    due_date: task.dueDate || '',
    priority: task.priority || 'medium',
    size: task.size || 'medium',
    subtasks: task.subtasks || [],
  }
}

export function medicationFromDb(row) {
  return {
    id: row.id,
    name: row.name,
    frequency: row.frequency || 'daily',
    timeOfDay: row.time_of_day || 'morning',
    reminderTime: row.reminder_time || '',
  }
}

export function medicationToDb(med, termId, userId) {
  return {
    id: med.id,
    term_id: termId,
    user_id: userId,
    name: med.name,
    frequency: med.frequency || 'daily',
    time_of_day: med.timeOfDay || 'morning',
    reminder_time: med.reminderTime || null,
  }
}

export function classFromDb(row) {
  return {
    id: row.id,
    name: row.name,
    startTime: row.start_time || '09:00',
    duration: row.duration || 50,
    days: row.days || [],
    location: row.location || '',
    professor: row.professor || '',
    notes: row.notes || '',
  }
}

export function classToDb(cls, termId, userId) {
  return {
    id: cls.id,
    term_id: termId,
    user_id: userId,
    name: cls.name,
    start_time: cls.startTime || '09:00',
    duration: cls.duration || 50,
    days: cls.days || [],
    location: cls.location || '',
    professor: cls.professor || '',
    notes: cls.notes || '',
  }
}
